<object *ngIf="!isEdgeOrIE11" [data]="getSafeUrl(pdfUri)" type="application/pdf" height="500px" width="98%"></object>
<iframe *ngIf="isEdgeOrIE11" [src]="getSafeUrl(pdfUri)" height="500px" width="98%"></iframe>



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/pdf/pdf.component.html